/* ============
 * The initial state of the careplan module.
 * ============
 */

export default {
  loading: false,
  careplanList: [],
  careplan: {},
  error: null,
  totalCount: 0,
  careplanTemplateList: [],
  careplanTemplate: {},
  searching: false,
  searchedCareplans: [],
  isCareplanLoading: false
};
